export default __webpack_public_path__ + "static/media/logo.db3810a9.png";